import React, { useEffect, useState } from "react";
import MainLayout from "../layout/MainLayout";
import Header from "../components/Header";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import axios from "axios";
import { baseUrl } from "../redux/index";
import Loader from "../components/loader/loader";
import { getAuthToken } from "../utils/utils";
import UnPaidCheckout from "./UnPaidCheckout";

const LeadCalculator = ({unPaid}) => {
  const [students, setStudents] = useState(0);
  const [loading, setLoading] = useState(false);
  const [conversionRates, setConversionRates] = useState({
    studentEnrolled: 0,
    showUpForAppointment: 0,
    appointmentsSet: 0,
    leadsContacted: 0,
    traffic: 0,
  });

  const { userDetails } = useSelector((state) => state.auth);
  const token = getAuthToken();
  const { userId } = userDetails;
  // Fetch the data when the component mounts
  useEffect(() => {
    const fetchData = async () => {
  
      setLoading(true);

      try {
        const response = await axios.get(`${baseUrl}/leadcalc/`, {
          params: { userId }, // Send userId to get user-specific data
          headers: {
            Authorization: `${token}`, // Pass the token here
            "Content-Type": "application/json", // Make sure the content type is correct
          },
        });
        const data = response.data;
        if (data) {
          setStudents(data.studentsStarts || 0);
          setConversionRates({
            studentEnrolled: data.studentsEnrolled || 0,
            showUpForAppointment: data.appointmentShow || 0,
            appointmentsSet: data.appointmentSet || 0,
            leadsContacted: data.leadsContacted || 0,
            traffic: data.trafficLeads || 0,
          });
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
  }, [userId]);

  const NOL1 =
    parseFloat(students / conversionRates.studentEnrolled).toFixed(2) * 100;
  const NOL2 =
    parseFloat(NOL1 / conversionRates.showUpForAppointment).toFixed(2) * 100;
  const NOL3 =
    parseFloat(NOL2 / conversionRates.appointmentsSet).toFixed(2) * 100;
  const NOL4 =
    parseFloat(NOL3 / conversionRates.leadsContacted).toFixed(2) * 100;
  const NOL5 = parseFloat(NOL4 / conversionRates.traffic).toFixed(2) * 100;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConversionRates((prevRates) => ({
      ...prevRates,
      studentEnrolled: parseInt(value),
    }));
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);

      const updatedData = {
        userId,
        studentsStarts: students,
        studentsEnrolled: conversionRates.studentEnrolled,
        appointmentShow: conversionRates.showUpForAppointment,
        appointmentSet: conversionRates.appointmentsSet,
        leadsContacted: conversionRates.leadsContacted,
        trafficLeads: conversionRates.traffic,
      };

      // Sending updated data to the backend API
      const response = await axios.put(`${baseUrl}/leadcalc`, updatedData, {
        headers: {
          Authorization: `${token}`, // Pass the token here
          "Content-Type": "application/json", // Ensure correct content type
        },
      });

      setLoading(false);

    } catch (error) {
      setLoading(false);
    }
  };

  const chartOptions = {
    chart: {
      id: "clinic-sales-bar",
    },
    xaxis: {
      categories: [
        "Students Enrolled",
        "Appointment Show",
        "Appointments Set",
        "Leads Contacted",
        "Traffic/Leads",
      ],
    },
    dataLabels: {
      enabled: false,
    },

    colors: ["#6C63FF"],
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "Lead Calculator",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "600",
      },
    },
  };

  const chartSeries = [
    {
      name: "Conversion Rate",
      data: [
        isNaN(NOL1)
          ? 0
          : isFinite(NOL1)
          ? parseFloat(NOL1).toExponential(0)
          : 0,
        isNaN(NOL2) ? 0 : isFinite(NOL2) ? parseFloat(NOL2).toFixed(0) : 0,
        isNaN(NOL3) ? 0 : isFinite(NOL3) ? parseFloat(NOL3).toFixed(0) : 0,
        isNaN(NOL4) ? 0 : isFinite(NOL4) ? parseFloat(NOL4).toFixed(0) : 0,
        isNaN(NOL5) ? 0 : isFinite(NOL5) ? parseFloat(NOL5).toFixed(0) : 0,
      ],
    },
  ];
  return (
    <>
      <MainLayout>
        <Loader loading={loading} />
        {
          unPaid ? (
            <UnPaidCheckout/>
          ) :
          (
            <>
            <div>
          {/* Header Component */}
          <Header
            title="Conversion Rate"
            // subTitle="4 Programs"
            description="Lead Calculator"
            btnOnlcick={handleUpdate}
            buttonText={"Update Records"}
          />

          <div className="p-10 flex flex-col gap-5">
            <table className="min-w-full text-left bg-white rounded-lg border border-collapse shadow-md p-6 mb-4">
              <tbody>
                <tr className="border bg-gray-50">
                  <td className="py-4 px-4 text-sm font-bold text-black border">
                    Phase
                  </td>
                  <td className="py-4 px-4 text-sm font-bold text-black border">
                    No Of Leads
                  </td>
                  <td className="py-4 px-4 text-sm font-bold text-black border">
                    Conversion Rate
                  </td>
                </tr>
                <tr>
                  <td className="py-4 px-4 text-sm border w-1/3">
                    Students Starts
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <input
                      type="number"
                      min={0}
                      value={students}
                      onChange={(e) => setStudents(e.target.value)}
                      required
                      className="w-full p-3 border-2 border-gray-500-2 border-gray-500 rounded-lg active:outline-purple-200 focus:outline-purple-500"
                    />
                  </td>
                  <td className="py-4 px-4 text-sm border w-1/3">-</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 text-sm border w-1/3">
                    Students Enrolled
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <span className="p-3">
                      {isNaN(NOL1)
                        ? 0
                        : isFinite(NOL1)
                        ? parseFloat(NOL1).toFixed(0)
                        : 0}
                    </span>
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <input
                      type="number"
                      min={0}
                      placeholder="Students That Enrolled"
                      value={conversionRates.studentEnrolled ?? 0}
                      onChange={handleChange}
                      required
                      className="w-11/12 p-3 border-2 border-gray-500 rounded-lg active:outline-purple-200 focus:outline-purple-500"
                    />
                    <span>%</span>
                  </td>
                </tr>
                <tr>
                  <td className="py-4 px-4 text-sm border w-1/3">
                    Appointment Show
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <span className="p-3">
                      {isNaN(NOL2)
                        ? 0
                        : isFinite(NOL2)
                        ? parseFloat(NOL2).toFixed(0)
                        : 0}
                    </span>
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <input
                      type="number"
                      min={0}
                      placeholder="Appointment Show"
                      value={conversionRates.showUpForAppointment ?? 0}
                      onChange={(e) =>
                        setConversionRates({
                          ...conversionRates,
                          showUpForAppointment: e.target.value,
                        })
                      }
                      required
                      className="w-11/12 p-3 border-2 border-gray-500 rounded-lg active:outline-purple-200 focus:outline-purple-500"
                    />
                    <span>%</span>
                  </td>
                </tr>

                <tr>
                  <td className="py-4 px-4 text-sm border w-1/3">
                    Appointment Set
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <span className="p-3">
                      {isNaN(NOL3)
                        ? 0
                        : isFinite(NOL3)
                        ? parseFloat(NOL3).toFixed(0)
                        : 0}
                    </span>
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <input
                      type="number"
                      min={0}
                      placeholder="Book Appointment"
                      value={conversionRates.appointmentsSet ?? 0}
                      onChange={(e) =>
                        setConversionRates({
                          ...conversionRates,
                          appointmentsSet: e.target.value,
                        })
                      }
                      required
                      className="w-11/12 p-3 border-2 border-gray-500 rounded-lg active:outline-purple-200 focus:outline-purple-500"
                    />
                    <span>%</span>
                  </td>
                </tr>

                <tr>
                  <td className="py-4 px-4 text-sm border w-1/3">
                    Leads Contacted
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <span className="p-3">
                      {isNaN(NOL4)
                        ? 0
                        : isFinite(NOL4)
                        ? parseFloat(NOL4).toFixed(0)
                        : 0}
                    </span>
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <input
                      type="number"
                      min={0}
                      placeholder="Payment"
                      value={conversionRates.leadsContacted ?? 0}
                      onChange={(e) =>
                        setConversionRates({
                          ...conversionRates,
                          leadsContacted: e.target.value,
                        })
                      }
                      required
                      className="w-11/12 p-3 border-2 border-gray-500 rounded-lg active:outline-purple-200 focus:outline-purple-500"
                    />
                    <span>%</span>
                  </td>
                </tr>

                <tr>
                  <td className="py-4 px-4 text-sm border w-1/3">
                    Traffic/Leads
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <span className="p-3">
                      {isNaN(NOL5)
                        ? 0
                        : isFinite(NOL5)
                        ? parseFloat(NOL5).toFixed(0)
                        : 0}
                    </span>
                  </td>
                  <td className="p-4 text-sm border w-1/3">
                    <input
                      type="number"
                      min={0}
                      placeholder="Enroll"
                      value={conversionRates.traffic ?? 0}
                      onChange={(e) =>
                        setConversionRates({
                          ...conversionRates,
                          traffic: e.target.value,
                        })
                      }
                      required
                      className="w-11/12 p-3 border-2 border-gray-500 rounded-lg active:outline-purple-200 focus:outline-purple-500"
                    />
                    <span>%</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="bg-gray-100 rounded-lg shadow-md p-6">
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height="300"
              />
            </div>
          </div>
          {/* <ReportModal showModal={showModal} setShowModal={setShowModal} /> */}
        </div>
            </>
          )
        }
      </MainLayout>
    </>
  );
};

export default LeadCalculator;
